import {useMediaQuery} from "@mantine/hooks";
import {em} from "@mantine/core";

const useIsMobile = () => {
  const isMobile = useMediaQuery(`(max-width: ${em(750)})`);

  return isMobile
}

export default useIsMobile
